import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { environment } from 'src/environments/environment';
import { ColorPickerControl } from '@iplab/ngx-color-picker';
import axios from 'axios';
import * as noUiSlider from 'nouislider';
import { TokenService } from 'src/app/auth/token.service';
import { EditorService } from 'src/app/components/editor/editor.service';
import { MusicPickerComponent } from 'src/app/components/music-picker/music-picker.component';
declare var $: any;

@Component({
  selector: 'app-control',
  templateUrl: './control.component.html',
  styleUrls: ['./control.component.css']
})
export class ControlComponent implements OnInit {
  @Input() controlType: any = '';
  @Input() layers: any = [];
  @Input() layerData: any = {};
  @Input() fontList: any = { results: [], page: 1 };
  @Input() boomGenres: any = [];
  @Input() lyricData: any = null;
  @Input() lyricSource: any = null;
  @Input() langCodeList: any = [];
  @Input() currentHub: any = { id: null, name: null, is_saved: true };
  @Input() isPortrait: boolean = false;
  @Output() changedControl = new EventEmitter();
  username: any = null;
  usertoken: any = null;
  channel: any = {};
  channelList: any = [];
  colorType: any = null;
  colorControl = new ColorPickerControl();
  videoList: any = { results: [], page: 1 };
  imageList: any = { results: [], page: 1 };
  audioList: any = { results: [], page: 1 };
  canvaList: any = { results: [], page: 1 };
  canvaImageList: any = { results: [], page: 1 };
  canvaFontList: any = { results: [], page: 1 };
  elementList: any = { results: [], page: 1 };
  urCanva: any = { video: { results: [], page: 1 }, image: { results: [], page: 1 }, font: { results: [], page: 1 }, channel: { id: null, name: null } };
  cateList: any = [];
  selectedCate: any = null;
  canvaGetType: any = null;
  imgSearchType: any = 'keyword';
  fontSearchType: any = 'locale';
  posType: any = null;
  maskColorInvalid: any = false;
  audioType: any = false;
  isLoading: any = false;
  limit: any = 20;
  highlightTag: any = {};
  mentionConfig: any = {};
  hubData: any = { al: 'random-order' };
  sourceData: any = {};
  sourceType: any = 1;
  genreList: any = [];
  sliders: any = {};
  effectSliders: any = [];
  claimList: any = [];

  constructor(private snackBar: MatSnackBar, private tokenService: TokenService, public editorService: EditorService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fontList) {
      this.username = this.tokenService.getUsername();
      this.usertoken = this.tokenService.getToken();
      axios.defaults.headers.common['aux'] = this.usertoken;
      this.getFonts();
    }
    if (changes.langCodeList) this.setMentionConfig();
    if (changes.layerData) {
      this.getSource();
      if (changes.layerData.currentValue.outro_claim_topic) this.getMusics(changes.layerData.currentValue.outro_claim_topic, 'outro', 0);
    }
    if (changes.isPortrait) this.getBoomGroups();
    $(() => {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }

  ngDoCheck() {
    if (this.layerData.meta) this.addTags(['title', 'description', 'tags', 'comment']);
    this.addTags(['lang_code']);
  }

  async ngOnInit() {
    const that = this;
    this.username = this.tokenService.getUsername();
    this.usertoken = this.tokenService.getToken();
    axios.defaults.headers.common['aux'] = this.usertoken;
    this.channel = JSON.parse(localStorage.getItem('currentChannel')) || { id: null, name: null };
    this.editorService.getChannels(this.username).then(results => this.channelList = results);
    this.initSlider();
    this.setMentionConfig();
    this.getGenre();
    this.getBoomGroups();
    this.getClaims().then((results: any) => this.claimList = results);

    this.getVideos();
    this.getImages();
    this.getAudio();
    this.getCates();
    this.getIntroTopics();
    // this.getCompositions();
    this.getSourceUsers();
    this.getElements();

    this.colorControl.valueChanges.subscribe((value: any) => {
      switch (this.colorType) {
        case 0:
          this.changedControl.emit({ id: this.layerData.id, type: 'backgroundColor', backgroundColor: value.toRgbaString() });
          break;
        case 1:
          this.changedControl.emit({ id: this.layerData.id, type: 'color', color: value.toRgbaString() });
          break;
        case 2:
          this.changedControl.emit({ id: this.layerData.id, type: 'strokeColor', strokeColor: value.toRgbaString() });
          break;
        case 3:
          this.changedControl.emit({ id: this.layerData.id, type: 'gradientColor1', color1: value.toHexString() });
          break;
        case 4:
          this.changedControl.emit({ id: this.layerData.id, type: 'gradientColor2', color2: value.toHexString() });
          break;
        case 5:
          const colorIndex = this.layerData.arr_color.findIndex(x => x == value.toHexString());
          if (colorIndex == -1 && this.layerData.arr_color.length < 5) this.layerData.arr_color.push(value.toHexString());
          else this.layerData.arr_color.splice(colorIndex, 1);
          this.changedControl.emit({ id: this.layerData.id, type: 'summonColor', summonColors: this.layerData.arr_color });
          break;
      }
    });
    $('#controlModal').on('hidden.bs.modal', function () {
      that.audioType = false;
    });
    $('#compilationModal, #mixLyricModal').on('hidden.bs.modal.musicBackup', function () {
      if (!that.musicBackup) return;
      const { id, key, data, comp_data } = that.musicBackup;
      // undo can replace layer objects while the modal is open
      const layer = that.layers.find(x => x.id == id) || that.layerData;
      layer[key] = data;
      layer.comp_data = comp_data;
      that.musicBackup = null;
    });
  }

  openSnackBar(message: any, duration: any = 5000) {
    this.snackBar.open(message, '', {
      duration: duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: duration != 5000 ? 'bg-primary' : 'bg-danger'
    });
  }

  fontChange(event: any) {
    let selectedOption = event.target.options[event.target.selectedIndex];
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'fontUrl',
      fontUrl: selectedOption.value,
      fontName: selectedOption.text,
      fontFormat: null,
      md5: null
    });
  }

  fontSizeChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'fontSize', fontSize: parseInt(event.target.value) || 0 });
  }

  strokeWidthChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'strokeWidth', strokeWidth: parseFloat(event.target.value) || null });
  }

  strokeColorChange(event: any) {
    this.colorType = 2;
    if (this.layerData.stroke_color) this.colorControl.setValueFrom(this.layerData.stroke_color);
  }

  clearStroke() {
    this.changedControl.emit({ id: this.layerData.id, type: 'strokeColor', strokeColor: null });
    this.changedControl.emit({ id: this.layerData.id, type: 'strokeWidth', strokeWidth: null });
  }

  textColorChange(event: any) {
    this.colorType = 1;
    if (this.layerData.color) this.colorControl.setValueFrom(this.layerData.color);
  }

  textBgColorChange(event: any) {
    this.colorType = 0;
    if (this.layerData.backgroundColor) this.colorControl.setValueFrom(this.layerData.backgroundColor);
  }

  clearBgColor() {
    this.changedControl.emit({ id: this.layerData.id, type: 'backgroundColor', backgroundColor: null });
  }

  startTimeChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'startTime', startTime: parseInt(event.target.value) || 0 });
  }

  durationChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'duration', duration: parseInt(event.target.value) || -1 });
  }

  wrapWidthChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'wrapWidth', wrapWidth: parseInt(event.target.value) || 30 });
  }

  numColumnsChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'numColumns', numColumns: parseInt(event.target.value) || 2 });
  }

  minSpacingChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'minSpacing', minSpacing: parseInt(event.target.value) || 100 });
  }

  paddingHChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'paddingH', paddingH: parseInt(event.target.value) || 15 });
  }

  marginChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'margin', margin: parseInt(event.target.value) || 10 });
  }

  xChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'x', x: parseInt(event.target.value) || 0 });
  }

  yChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'y', y: parseInt(event.target.value) || 0 });
  }

  widthChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'width', width: parseInt(event.target.value) || 0 });
  }

  heightChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'height', height: parseInt(event.target.value) || 0 });
  }

  rotateChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rotate', rotate: parseInt(event.target.value) || 0 });
  }

  textReplaceKeyChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'textReplaceKey', textReplaceKey: event.target.value });
  }

  textReplaceValueChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'textReplaceValue', textReplaceValue: event.target.value });
  }

  opacityChange(event: any) {
    let opacityLevel = parseFloat(event.target.value) || 0;
    if (opacityLevel >= 0 && opacityLevel <= 1) this.changedControl.emit({ id: this.layerData.id, type: 'opacity', opacity: opacityLevel });
  }

  sendBackward() {
    this.layerData.index -= 1;
    if (this.layerData.index < 0) this.layerData.index = 0;
    this.changedControl.emit({ id: this.layerData.id, type: 'sendBackward', sendBackward: this.layerData.index });
  }

  bringForward() {
    this.layerData.index += 1;
    this.changedControl.emit({ id: this.layerData.id, type: 'bringForward', bringForward: this.layerData.index });
  }

  cloneLayer() {
    this.changedControl.emit({ id: this.layerData.id, type: 'cloneLayer' });
  }

  deleteLayer(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'delete' });
  }

  setAsBackground() {
    this.changedControl.emit({ id: this.layerData.id, type: 'setAsBackground' });
  }

  setAsIntro() {
    this.layerData.is_intro = !this.layerData.is_intro;
    this.changedControl.emit({ id: this.layerData.id, type: 'setAsIntro', isIntro: this.layerData.is_intro });
  }

  useMusicBgChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'useMusicBg', useMusicBg: event.target.checked });
  }

  setAsOutro() {
    this.layerData.is_outro = !this.layerData.is_outro;
    this.changedControl.emit({ id: this.layerData.id, type: 'setAsOutro', isOutro: this.layerData.is_outro });
  }

  textClick(text: any, mapType: any) {
    if (this.controlType != 'text') return;
    this.changedControl.emit({ id: this.layerData.id, type: 'text', text: text, mapType: mapType });
  }

  textChange(value: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'text', text: value });
  }

  setMentionConfig() {
    this.mentionConfig = {
      mentions: [
        {
          items: this.langCodeList,
          labelKey: 'name',
          triggerChar: '@',
          mentionSelect: item => item.code,
          mentionFilter: this.mentionFilter
        },
        {
          items: this.langCodeList,
          labelKey: 'name',
          triggerChar: '#',
          mentionSelect: item => item.code.replace(/@@/g, '##'),
          mentionFilter: this.mentionFilter
        }
      ]
    };
  }

  mentionFilter(filterValue: any, items: any) {
    return items.filter(item => item.name.toLowerCase().includes(filterValue));
  }

  addTags(keys: any) {
    let matchMentions: any = /(@@\w+@@) ?/g;
    let matchHashtags: any = /(##\w+##) ?/g;
    for (let key of keys) {
      this.highlightTag[key] = [];
      let text = '';
      if (key == 'lang_code') text = this.layerData[key];
      else text = this.layerData.meta[key];
      let mention;
      while ((mention = matchMentions.exec(text))) {
        this.highlightTag[key].push({
          indices: {
            start: mention.index,
            end: mention.index + mention[1].length
          },
          data: mention[1],
          cssClass: mention[1].includes('env') ? 'bg-danger' : 'bg-primary'
        });
      }
      let hashtag;
      while ((hashtag = matchHashtags.exec(text))) {
        this.highlightTag[key].push({
          indices: {
            start: hashtag.index,
            end: hashtag.index + hashtag[1].length
          },
          data: hashtag[1],
          cssClass: 'bg-yellow'
        });
      }
    }
  }

  tplCodeChange(value: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'tplCode', tplCode: value });
    this.addTags(['lang_code']);
  }

  linkLayerChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'linkLayer', linkLayer: event.target.value });
  }

  muteChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'mute', isMute: event.target.checked });
  }

  loopChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'loop', isLoop: event.target.checked });
  }

  canvasBgChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'canvasBg', isBackground: event.target.checked });
  }

  smoothLoopChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'smoothLoop', isSmoothLoop: event.target.checked });
  }

  smoothFadeChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'smoothFade', isSmoothFade: event.target.checked });
  }

  msSourceTypeChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'msSourceType', msSourceType: event.target.value });
  }

  maskChange(event: any) {
    if (event.target.checked && this.layerData.maskColor.length == 0) {
      this.maskColorInvalid = true;
    } else {
      this.maskColorInvalid = false;
    }
    this.changedControl.emit({ id: this.layerData.id, type: 'mask', isMask: event.target.checked });
  }

  maskColorChange(event: any, isClick: any = false) {
    let colorValue;
    if (isClick) colorValue = event;
    else colorValue = event.target.value;
    if (colorValue.length == 0) {
      this.maskColorInvalid = true;
    } else {
      if (colorValue.includes(',')) {
        let colorList = colorValue.split(',');
        colorList = colorList.map(e => parseInt(e));
        this.changedControl.emit({ id: this.layerData.id, type: 'maskColor', maskColor: colorList });
        this.maskColorInvalid = false;
      }
    }
  }

  smartCropChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'smartCrop', smartCrop: event.target.checked });
  }

  trimSilenceChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'isTrimSilence', isTrimSilence: event.target.checked });
  }

  strictChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'strict', strict: event.target.checked });
  }

  silenceThresholdChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'silenceThreshold', silenceThreshold: Number(event.target.value) || -30 });
  }

  positionClick(value: any) {
    this.changedControl.emit({ id: this.layerData.id, type: `pos${value}` });
    this.posType = value;
  }

  lockRatioClick() {
    this.layerData.isLockRatio = !this.layerData.isLockRatio;
    this.changedControl.emit({ id: this.layerData.id, type: 'lockRatio', isLockRatio: this.layerData.isLockRatio });
  }

  audioClick() {
    this.audioType = true;
    this.showOverlay();
  }

  clearAudio() {
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'browseAudio',
      directUrl: null,
      ext: null,
      url: null,
      md5: null
    });
  }

  audioLoopChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'audioLoop', audioLoop: event.target.checked });
  }

  color1Change(event: any) {
    this.colorType = 3;
    if (this.layerData.gradient.color1) this.colorControl.setValueFrom(this.layerData.gradient.color1);
  }

  color2Change(event: any) {
    this.colorType = 4;
    if (this.layerData.gradient.color2) this.colorControl.setValueFrom(this.layerData.gradient.color2);
  }

  directionChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'gradientDirection', direction: event.target.value });
  }

  editLyricClick() {
    this.changedControl.emit({ id: this.layerData.id, type: 'editLyric' });
  }

  fullSizeLayer() {
    this.changedControl.emit({ id: this.layerData.id, type: 'fullSizeLayer' });
  }

  rateSummonChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rateSummon', rateSummon: parseInt(event.target.value) || 0 });
  }

  clearSummonTemplate() {
    this.changedControl.emit({ id: this.layerData.id, type: 'summonTemplate', summonTemplates: [] });
  }

  // rangLocX1Change(event: any) {
  //   this.changedControl.emit({ id: this.layerData.id, type: 'rangLocX1', rangLocX1: parseInt(event.target.value) || 0 });
  // }

  // rangLocX2Change(event: any) {
  //   this.changedControl.emit({ id: this.layerData.id, type: 'rangLocX2', rangLocX2: parseInt(event.target.value) || 0 });
  // }

  // rangLocY1Change(event: any) {
  //   this.changedControl.emit({ id: this.layerData.id, type: 'rangLocY1', rangLocY1: parseInt(event.target.value) || 0 });
  // }

  // rangLocY2Change(event: any) {
  //   this.changedControl.emit({ id: this.layerData.id, type: 'rangLocY2', rangLocY2: parseInt(event.target.value) || 0 });
  // }

  rangSpeedX1Change(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rangSpeedX1', rangSpeedX1: parseInt(event.target.value) || 0 });
  }

  rangSpeedX2Change(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rangSpeedX2', rangSpeedX2: parseInt(event.target.value) || 0 });
  }

  rangSpeedY1Change(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rangSpeedY1', rangSpeedY1: parseInt(event.target.value) || 0 });
  }

  rangSpeedY2Change(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rangSpeedY2', rangSpeedY2: parseInt(event.target.value) || 0 });
  }

  rangOpacity1Change(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rangOpacity1', rangOpacity1: parseInt(event.target.value) || 0 });
  }

  rangOpacity2Change(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rangOpacity2', rangOpacity2: parseInt(event.target.value) || 0 });
  }

  delayChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'delay', delay: parseInt(event.target.value) || 0 });
  }

  rangSize1Change(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rangSize1', rangSize1: parseInt(event.target.value) || 0 });
  }

  rangSize2Change(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'rangSize2', rangSize2: parseInt(event.target.value) || 0 });
  }

  summonColor() {
    this.colorType = 5;
  }

  clearSummonColor() {
    this.changedControl.emit({ id: this.layerData.id, type: 'summonColor', summonColors: [] });
  }

  deleteSummonColor(color: any) {
    const colorIndex = this.layerData.arr_color.findIndex(x => x == color);
    if (colorIndex > -1) this.layerData.arr_color.splice(colorIndex, 1);
    this.changedControl.emit({ id: this.layerData.id, type: 'summonColor', summonColors: this.layerData.arr_color });
  }

  isFadeInChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'isFadeIn', isFadeIn: event.target.checked });
  }

  fadeInChange(value: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'fadeIn', fadeIn: value });
  }

  isFadeOutChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'isFadeOut', isFadeOut: event.target.checked });
  }

  fadeOutChange(value: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'fadeOut', fadeOut: value });
  }

  lyricMovingChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'lyricMoving', lyricMoving: event.target.checked });
  }

  lyricLinesChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'lyricLines', lyricLines: parseInt(event.target.value) || 2 });
  }

  lyricOutroChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'isLyricOutro', isLyricOutro: event.target.checked });
  }

  isKeepedChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'isKeeped', isKeeped: event.target.checked });
  }

  lyricOutroRepeatChange(value: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'lyricOutroRepeat', lyricOutroRepeat: value });
  }

  deezerArtistIdChange(value: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'deezerArtistId', deezerArtistId: value });
  }

  outroClaimChange(event: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'isOutroClaim', isOutroClaim: event.target.checked });
  }

  outroClaimTopicChange(value: any) {
    if (!value || value == 'NO_CLAIM' || value == 'NO_PROMO') {
      this.musicList.outro = [];
      this.layerData.outro_claim_music = [];
    } else this.getMusics(value, 'outro', 0);
    this.changedControl.emit({ id: this.layerData.id, type: 'outroClaimTopic', outroClaimTopic: value });
  }

  outroClaimMusicChange(values: any) {
    this.changedControl.emit({ id: this.layerData.id, type: 'outroClaimMusic', outroClaimMusic: values });
  }

  boomXChange(currentValues: any, type: 'booms_x' | 'claims' | 'promos') {
    const previousValues = this.sourceData[type] || [];
    this.sourceData[type] = currentValues;
    const diffValues = type == 'booms_x'
      ? [
          ...previousValues.filter((x: any) => !currentValues.some((y: any) => y.id === x.id)),
          ...currentValues.filter((x: any) => !previousValues.some((y: any) => y.id === x.id))
        ]
      : [
          ...previousValues.filter((x: string) => !currentValues.includes(x)),
          ...currentValues.filter((x: string) => !previousValues.includes(x))
        ];
    if (!this.sourceData.sources) this.sourceData.sources = [];
    for (const value of diffValues) {
      let uri: string, musicType: string, refId: any;
      if (type == 'booms_x') {
        refId = value.id;
        uri = `deezer:boom:GROUP__${value.id}`;
        musicType = value.type;
      } else {
        refId = value;
        const prefix = type == 'claims' ? 'CLAIM' : 'PROMO';
        uri = `deezer:boom:${prefix}__${value}__${this.username}`;
        musicType = prefix;
      }
      const musicIdx = `${type};;${refId}`;
      const existingIdx = this.sourceData.sources.findIndex((x: any) => x.music_idx === musicIdx);
      if (existingIdx == -1) this.sourceData.sources.push({ uri, number_vip: 1, repeat: 1, music_type: musicType, music_idx: musicIdx });
      else this.sourceData.sources = this.sourceData.sources.filter((x: any) => x.music_idx !== musicIdx);
    }
    this.sourceValidationErrors.clear();
  }

  cloneSource(item: any) {
    if (!item?.music_idx) return;
    const pos = this.sourceData.sources.indexOf(item);
    this.sourceData.sources.splice(pos + 1, 0, { ...item });
    this.sourceValidationErrors.clear();
  }

  removeSource(item: any, index: number) {
    if (!item.music_idx) return;
    const [type, refId] = item.music_idx.split(';;');
    const count = this.sourceData.sources.filter((x: any) => x.music_idx === item.music_idx).length;
    if (count < 2) {
      if (type === 'booms_x') this.sourceData.booms_x = this.sourceData.booms_x.filter((g: any) => String(g.id) !== refId);
      else this.sourceData[type] = this.sourceData[type].filter((t: string) => t !== refId);
    }
    this.sourceData.sources.splice(index, 1);
    this.sourceValidationErrors.clear();
  }

  musicList: any = { outro: [] };

  getMusics(value: any, type: any, index: any) {
    if (!value || value == 'NO_CLAIM' || value == 'NO_PROMO') return;
    this.editorService.getClaimMusics(value, this.username)
      .then((results: any) => {
        this.musicList[type][index] = results;
        if (!results.length) this.openSnackBar('You have uploaded more than limit videos claim per week');
      })
      .catch(() => { });
  }

  sourceDrop(event: any) {
    moveItemInArray(this.sourceData.sources, event.previousIndex, event.currentIndex);
  }

  claimTopics: any = [];
  promoTopics: any = [];

  @ViewChildren('musicPicker') musicPickers: QueryList<MusicPickerComponent>;

  get currentMusicPicker() {
    const mode = this.controlType == 'mix_lyric' ? 'mix_lyric' : 'compilation';
    return this.musicPickers?.find(x => x.mode == mode);
  }

  musicBackup: { id: any; key: 'music_data' | 'mix_data'; data?: any[]; comp_data?: any } | null = null;

  async btnAddMusic(event: any) {
    const key = this.controlType == 'mix_lyric' ? 'mix_data' : 'music_data';
    this.musicBackup = JSON.parse(JSON.stringify({ id: this.layerData.id, key, data: this.layerData[key], comp_data: this.layerData.comp_data }));
    if (!this.layerData.comp_data) return;
    if (!this.layerData.comp_data.booms) {
      this.layerData.comp_data.booms = [{ genre: undefined, musics: [] }];
      if (this.layerData.comp_data.boom_genre) {
        this.layerData.comp_data.booms[0] = { genre: this.layerData.comp_data.boom_genre, musics: this.layerData.comp_data.boom_music };
        delete this.layerData.comp_data.boom_genre;
        delete this.layerData.comp_data.boom_music;
      }
      if (this.layerData.comp_data.boom2_genre) {
        this.layerData.comp_data.booms[1] = { genre: this.layerData.comp_data.boom2_genre, musics: this.layerData.comp_data.boom2_music };
        delete this.layerData.comp_data.boom2_genre;
        delete this.layerData.comp_data.boom2_music;
      }
    }
    if (!this.layerData.comp_data.groups) {
      this.layerData.comp_data.groups = [{ genre: undefined, musics: [] }];
    }
    if (!this.layerData.comp_data.claims) {
      this.layerData.comp_data.claims = [{ topic: 'NO_CLAIM', musics: [] }];
      if (this.layerData.comp_data.claim_topic) {
        this.layerData.comp_data.claims[0] = { topic: this.layerData.comp_data.claim_topic, musics: this.layerData.comp_data.claim_music };
        delete this.layerData.comp_data.claim_topic;
        delete this.layerData.comp_data.claim_music;
      }
      if (this.layerData.comp_data.claim2_topic) {
        this.layerData.comp_data.claims[1] = { topic: this.layerData.comp_data.claim2_topic, musics: this.layerData.comp_data.claim2_music };
        delete this.layerData.comp_data.claim2_topic;
        delete this.layerData.comp_data.claim2_music;
      }
    }
    if (!this.layerData.comp_data.promos) {
      this.layerData.comp_data.promos = [{ topic: 'NO_PROMO', musics: [] }];
      if (this.layerData.comp_data.promo_topic) {
        this.layerData.comp_data.promos[0] = { topic: this.layerData.comp_data.promo_topic, musics: this.layerData.comp_data.promo_music };
        delete this.layerData.comp_data.promo_topic;
        delete this.layerData.comp_data.promo_music;
      }
      if (this.layerData.comp_data.promo2_topic) {
        this.layerData.comp_data.promos[1] = { topic: this.layerData.comp_data.promo2_topic, musics: this.layerData.comp_data.promo2_music };
        delete this.layerData.comp_data.promo2_topic;
        delete this.layerData.comp_data.promo2_music;
      }
    }
    if (!this.layerData.meta) this.layerData.meta = { boommix_update_title: true, public_x: true };
    this.normalizeAutoMeta(this.layerData.meta);
    this.currentMusicPicker?.init();
  }

  musicValidationErrors: Set<number> = new Set();

  saveCompilation(event: any) {
    const hasTracks = this.layerData.music_data.some(x => !x.uri.includes('automusic:source'));
    const musicError = hasTracks ? this.currentMusicPicker?.validate() : null;
    if (!hasTracks) this.openSnackBar('Please add at least one track');
    else if (musicError) this.openSnackBar(musicError);
    else if (this.layerData.meta.schedule != null && this.layerData.meta.schedule.some(x => x.date == null || x.time == null || x.time_zone == null)) this.openSnackBar('Please fill in all the schedule fields');
    else if (!this.layerData.meta.title
      || (!this.layerData.meta.is_desc_empty && !this.layerData.meta.description)
      || (!this.layerData.meta.is_tags_empty && !this.layerData.meta.tags)) this.openSnackBar('Please fill in all the meta fields');
    else {
      const validationResult = this.editorService.validateMusicSequence(this.layerData.music_data);
      if (!validationResult.isValid) {
        this.musicValidationErrors = new Set(validationResult.errorIndexes);
        this.openSnackBar(this.editorService.musicSequenceError(validationResult));
      } else {
        this.musicValidationErrors.clear();
        this.changedControl.emit({
          id: this.layerData.id,
          type: 'compilation',
          compData: this.layerData.comp_data,
          musicData: this.layerData.music_data.filter(x => !x.uri.includes('automusic:source')),
          meta: this.layerData.meta
        });
        this.musicBackup = null;
        $('#compilationModal').modal('hide');
        this.mapSongToTextList();
        let boom_deezer_ids = this.layerData.music_data.filter(x => x.boom_deezer_id).map(x => x.boom_deezer_id).join(',');
        let uri = encodeURIComponent(`${environment.music}/bom/update?deezer_ids=${boom_deezer_ids}&username=${this.username}`);
        axios.get(`/pass/${uri}`)
          .catch((error) => console.log(error));
      }
    }
  }

  mapSongToTextList() {
    let textListResult = '';
    let data = this.controlType == 'mix_lyric' ? this.layerData.mix_data : this.layerData.music_data;
    for (const [i, value] of data.entries()) {
      try {
        textListResult += `${this.layerData.text_list_config.replace('%song_name%', data[i].song_name).replace('%artist_name%', data[i].artist_name)}\n`;
      } catch (error) { }
    }
    let textListLayer = this.layers.find(x => x.type == 'text_list');
    if (textListLayer) textListLayer.text = textListResult.trim();
  }

  musicTimestamp: any = '';

  genTimestamp() {
    this.musicTimestamp = '';
    let data = this.controlType == 'mix_lyric' ? this.layerData.mix_data : this.layerData.music_data;
    let lastDurationMs = 0;
    for (const [i, value] of data.entries()) {
      try {
        if (i == 0) {
          this.musicTimestamp = `00:00:00 ${data[i].artist_name ?? ''} - ${data[i].song_name ?? ''}\n`;
          continue;
        }
        lastDurationMs += data[i - 1].duration_ms || 180000;
        let time = new Date(lastDurationMs).toISOString().slice(11, 19);
        this.musicTimestamp += `${time} ${data[i].artist_name ?? ''} - ${data[i].song_name ?? ''}\n`;
      } catch (error) { }
    }
  }

  genTimestampSRT() {
    let data = this.controlType === 'mix_lyric' ? this.layerData.mix_data : this.layerData.music_data;
    let srtContent = '';
    let startTimeMs = 0;
    for (let i = 0; i < data.length; i++) {
      try {
        const entry = data[i];
        const nextStartTimeMs = startTimeMs + (entry.duration_ms || 180000);
        const start = new Date(startTimeMs).toISOString().slice(11, 23).replace('.', ',');
        const end = new Date(nextStartTimeMs - 1).toISOString().slice(11, 23).replace('.', ',');
        srtContent += `${i + 1}\n${start} --> ${end}\n${entry.artist_name ?? ''} - ${entry.song_name ?? ''}\n\n`;
        startTimeMs = nextStartTimeMs;
      } catch (error) {}
    }

    const blob = new Blob([srtContent], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `caption-${Date.now()}.srt`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  totalTimestamp() {
    return this.editorService.totalTimestamp(this.controlType == 'mix_lyric' ? this.layerData.mix_data : this.layerData.music_data);
  }

  resetMusicData() {
    this.currentMusicPicker?.reset();
    this.musicValidationErrors.clear();
  }

  isTextUpperChange(event: any, type: any) {
    if (event.target.checked) this.layerData.meta[`is_${type}_upper`] = true;
    else {
      this.layerData.meta[`is_${type}_upper`] = false;
      if (this.layerData.meta.hasOwnProperty(`${type}_ucfirst`)) delete this.layerData.meta[`${type}_ucfirst`];
      if (this.layerData.meta.hasOwnProperty(`${type}_ucword`)) delete this.layerData.meta[`${type}_ucword`];
    }
  }

  isTextEmptyChange(event: any, type: any) {
    if (event.target.checked) this.layerData.meta[`is_${type}_empty`] = true;
    else delete this.layerData.meta[`is_${type}_empty`];
  }

  isTextFontChanged(event: any, type: any) {
    if (event.target.checked) this.layerData.meta[`is_${type}_font_changed`] = true;
    else {
      this.layerData.meta[`is_${type}_font_changed`] = false;
      if (this.layerData.meta.hasOwnProperty(`fc_${type}_first_letter`)) delete this.layerData.meta[`fc_${type}_first_letter`];
      if (this.layerData.meta.hasOwnProperty(`fc_${type}_font_name`)) delete this.layerData.meta[`fc_${type}_font_name`];
    }
  }

  textFontChanged(event: any, type: any) {
    this.layerData.meta[`fc_${type}_font_name`] = event.target.value;
    this.layerData.meta[`fc_${type}_first_letter`] = '';
  }

  textFirstLetterChanged(event: any, type: any) {
    if (event.target.checked) this.layerData.meta[`fc_${type}_first_letter`] = ' ';
    else this.layerData.meta[`fc_${type}_first_letter`] = '';
  }

  textCapChange(event: any, type: any) {
    if (event.target.checked) this.layerData.meta[`${type}_ucfirst`] = true;
    else delete this.layerData.meta[`${type}_ucfirst`];
  }

  textUpperChange(event: any, type: any) {
    if (event.target.checked) this.layerData.meta[`${type}_ucword`] = true;
    else delete this.layerData.meta[`${type}_ucword`];
  }

  textLowerChange(event: any, type: any) {
    if (event.target.checked) this.layerData.meta[`${type}_lowercase`] = true;
    else delete this.layerData.meta[`${type}_lowercase`];
  }

  videoTitleChange(value: any) {
    this.layerData.meta.title = value;
    this.addTags(['title']);
  }

  videoDescChange(value: any) {
    value = (value || '').replace('<', '').replace('>', '');
    this.layerData.meta.description = value;
    this.addTags(['description']);
  }

  videoDescValidate(event: any) {
    return new RegExp(/[^<>]/).test(event.key);
  }

  videoTagsChange(value: any) {
    this.layerData.meta.tags = value;
    this.addTags(['tags']);
  }

  commentChange(value: any) {
    this.layerData.meta.comment = value;
    this.addTags(['comment']);
  }

  scheduleChange(event: any) {
    if (event.target.checked) this.layerData.meta.schedule = [{ date: new Date().toLocaleDateString('en-US'), seq_type: 'daily', seq_data: '', time: null, time_zone: 'GMT+07:00' }];
    else this.layerData.meta.schedule = null;
  }

  bindDate(d: any) {
    return (new FormControl(new Date(d))).value;
  }

  dateScheduleChange(event: any, index: any) {
    let d = new Date(event.value);
    this.layerData.meta.schedule[index].date = d.toLocaleDateString('en-US');
  }

  seqTypeChange(event: any, index: any) {
    let item = this.layerData.meta.schedule[index];
    if (event.target.value) item.seq_type = event.target.value;
    if (event.target.value == 'daily') item.seq_data = '';
  }

  seqDataChange(value: any, index: any) {
    this.layerData.meta.schedule[index].seq_data = value;
  }

  validSeqData(event: any, type: any) {
    let pattern: any = '';
    if (type === 'weekly') pattern = /[1-7,-]/;
    else if (type == 'monthly') pattern = /[0-9,-]/;
    return new RegExp(pattern).test(event.key);
  }

  timeScheduleChange(values: any, index: any) {
    this.layerData.meta.schedule[index].time_random = values;
    if (values.length) this.layerData.meta.schedule[index].time = values[0];
    else this.layerData.meta.schedule[index].time = null;
  }

  tzScheduleChange(event: any, index: any) {
    this.layerData.meta.schedule[index].time_zone = event.target.value;
  }

  deleteSchedule(index: any) {
    if (this.layerData.meta.schedule.length > 1) this.layerData.meta.schedule.splice(index, 1);
  }

  addSchedule(index: any) {
    let s = this.layerData.meta.schedule[index];
    this.layerData.meta.schedule.push({
      date: s.date,
      seq_type: s.seq_type,
      seq_data: s.seq_data,
      time: s.time,
      time_zone: s.time_zone,
      time_random: s.time_random || []
    });
  }

  get autoCardEnabled(): boolean {
    return !!this.layerData?.meta?.auto_card;
  }

  set autoCardEnabled(value: boolean) {
    this.layerData.meta.auto_card = value ? { target_video_id: '' } : null;
  }

  get autoEndscreenEnabled(): boolean {
    return !!this.layerData?.meta?.auto_endscreen;
  }

  set autoEndscreenEnabled(value: boolean) {
    this.layerData.meta.auto_endscreen = value ? { target_video_id: '' } : null;
  }

  normalizeAutoMeta(meta: any) {
    if (!meta) return;
    if (typeof meta.auto_card === 'boolean') {
      let targetVideoId = '';
      const videoCard = meta.payload_card?.infoCardEdit?.infoCards?.find((c: any) => c.videoInfoCard?.videoId);
      if (videoCard) targetVideoId = videoCard.videoInfoCard.videoId;
      meta.auto_card = meta.auto_card ? { target_video_id: targetVideoId } : null;
    }
    if (typeof meta.auto_endscreen === 'boolean') {
      let targetVideoId = '';
      const videoElement = meta.payload_endscreen?.endscreenEdit?.endscreen?.elements?.[1]?.videoEndscreenElement;
      if (videoElement?.videoType == 'VIDEO_TYPE_FIXED' && videoElement.encryptedVideoId) targetVideoId = videoElement.encryptedVideoId;
      meta.auto_endscreen = meta.auto_endscreen ? { target_video_id: targetVideoId } : null;
    }
  }

  parseYoutubeId(event: any) {
    let text = event.target.value.trim();
    if (text.includes('youtube.com') || text.includes('youtu.be')) {
      if (text.includes('playlist')) text = text.match(/list=(.*?)(&|$)/)[1];
      else if (text.includes('channel')) text = text.split('/').pop();
      else text = text.includes('youtube.com') ? text.match(/v=(.*?)(&|$)/)[1] : text.split('/').pop();
    }
    return text;
  }

  saveMixLyric(event: any) {
    const musicError = this.currentMusicPicker?.validate();
    if (musicError) this.openSnackBar(musicError);
    else if (this.layerData.meta.schedule != null && this.layerData.meta.schedule.some(x => x.date == null || x.time == null || x.time_zone == null)) this.openSnackBar('Please fill in all the schedule fields');
    else if (!this.layerData.meta.title
      || (!this.layerData.meta.is_desc_empty && !this.layerData.meta.description)
      || (!this.layerData.meta.is_tags_empty && !this.layerData.meta.tags)) this.openSnackBar('Please fill in all the meta fields');
    else if (this.layerData.mix_data.some(x => !x.lyric_sync)) this.openSnackBar('Some songs have no lyrics');
    else if (this.layerData.meta.auto_card && !this.layerData.meta.auto_card.target_video_id) this.openSnackBar('Please fill in all card fields');
    else if (this.layerData.meta.auto_endscreen && !this.layerData.meta.auto_endscreen.target_video_id) this.openSnackBar('Please fill in all endscreen fields');
    else {
      const validationResult = this.editorService.validateMusicSequence(this.layerData.mix_data);
      if (!validationResult.isValid) {
        this.musicValidationErrors = new Set(validationResult.errorIndexes);
        this.openSnackBar(this.editorService.musicSequenceError(validationResult));
      } else {
        this.musicValidationErrors.clear();
        this.changedControl.emit({
          id: this.layerData.id,
          type: 'mix_lyric',
          compData: this.layerData.comp_data,
          mixData: this.layerData.mix_data.map((e, i) => {
            if (e.has_lyric === false || (e.has_lyric === undefined && i > 2)) e.lyric_sync = "[{\"milliseconds\":1555,\"line\":\"...\"}]";
            return e
          }),
          meta: this.layerData.meta
        });
        this.musicBackup = null;
        $('#mixLyricModal').modal('hide');
        this.mapSongToTextList();
        let boom_deezer_ids = this.layerData.mix_data.filter(x => x.boom_deezer_id).map(x => x.boom_deezer_id).join(',');
        let uri = encodeURIComponent(`${environment.music}/bom/update?deezer_ids=${boom_deezer_ids}&username=${this.username}`);
        axios.get(`/pass/${uri}`)
          .catch((error) => console.log(error));
      }
    }
  }

  defaultSource() {
    this.sourceData = { is_distinct_artist: true };
    if (this.sourceType == 1) Object.assign(this.sourceData, { market: 'US', limit: 10 });
    else if (this.sourceType == 2) Object.assign(this.sourceData, { number_track_playlist: 20, number_track_radio: 10 });
    else if (this.sourceType == 3) Object.assign(this.sourceData, { number_track_video: '8-12', is_radio_vip: false, is_rand_pick: false, is_mix_playlist: true, repeat: 1, positions: this.layerData && this.layerData.type == 'lyric' ? [{ start: 90, end: 100, value: '1-1' }] : [{ start: 0, end: 10, value: '1-1' }], track_vip: '1-1' });
    else if (this.sourceType == 8) Object.assign(this.sourceData, { booms_x: [], claims: [], promos: [], is_distinct_artist: false, repeat_all: 1, is_music_short: this.isPortrait, ...(this.isPortrait ? { short_choosing: 'priority' } : {}) });
    else Object.assign(this.sourceData, { number_track_video: this.sourceType == 7 ? '1-1' : '8-12', is_rand_pick: false, is_mix_playlist: true, repeat: 1, positions: this.layerData && this.layerData.type == 'lyric' ? [{ start: 90, end: 100, value: '1-1' }] : [{ start: 0, end: 10, value: '1-1' }], track_vip: '1-1' });
  }

  async getSource() {
    if (this.sourceType == 8) {
      this.getClaims('CLAIM').then((results: any) => this.claimTopics = results);
      this.getClaims('PROMOS').then((results: any) => this.promoTopics = results);
    }
    let sourceId = '';
    if (this.controlType.includes('collection:music')) sourceId = this.controlType.split(':').pop();
    else if (this.layerData.source_id) sourceId = this.layerData.source_id;
    if (!sourceId) this.defaultSource();
    else {
      try {
        let uri = encodeURIComponent(`${environment.source}/config/load/${sourceId}`);
        let response = await axios.get(`/pass/${uri}`);
        if (this.sourceType == response.data.type) {
          this.sourceData = JSON.parse(response.data.data);
          if (this.sourceType != 1 && this.sourceType != 2) {
            this.rangeOptions = { start: [], connect: [false], input: [] };
            for (let item of this.sourceData.positions) {
              this.rangeOptions.start = [...this.rangeOptions.start, item.start, item.end];
              this.rangeOptions.connect = [...this.rangeOptions.connect, true, false];
              this.rangeOptions.input = [...this.rangeOptions.input, item.value];
            }
          }
          for (const [key, value] of Object.entries(this.sliders)) {
            if (key in this.sourceData) {
              if (key == 'claim') {
                let parts = this.sourceData[key].position.split(',');
                this.sliders[key].minValue = parseInt(parts[0]);
                this.sliders[key].maxValue = parseInt(parts[1]);
              } else {
                this.sliders[key].minValue = this.sourceData[key].min;
                this.sliders[key].maxValue = this.sourceData[key].max;
              }
            }
          }
          if (this.sourceData.claim && this.sourceData.claim.topic_type) this.claimList = await this.getClaims(this.sourceData.claim.topic_type);
          if (this.sourceType == 8) {
            if (!this.sourceData.booms_x) this.sourceData.booms_x = [];
            if (!this.sourceData.claims) this.sourceData.claims = [];
            if (!this.sourceData.promos) this.sourceData.promos = [];

            // migrate old {group}/{topic} row arrays to flat arrays, deduped (repeats now live as duplicate music_idx entries in sources)
            if (this.sourceData.booms_x.some((x: any) => x?.group !== undefined)) {
              const seenIds = new Set();
              this.sourceData.booms_x = this.sourceData.booms_x
                .map((x: any) => typeof x.group === 'string' ? { id: +x.group.split('__')[1] } : x.group)
                .filter((g: any) => !seenIds.has(g?.id) && seenIds.add(g?.id));
            }
            this.sourceData.booms_x = this.sourceData.booms_x.filter((g: any) => g?.id != null);
            if (this.sourceData.claims.some((x: any) => x?.topic !== undefined)) {
              this.sourceData.claims = [...new Set(this.sourceData.claims.map((x: any) => x?.topic).filter((t: any) => t && t !== 'NO_CLAIM'))];
            }
            if (this.sourceData.promos.some((x: any) => x?.topic !== undefined)) {
              this.sourceData.promos = [...new Set(this.sourceData.promos.map((x: any) => x?.topic).filter((t: any) => t && t !== 'NO_PROMO'))];
            }

            this.sourceData.sources?.forEach((src: any) => {
              if (src.music_idx === undefined && src.uri?.includes('GROUP__')) {
                src.music_idx = `booms_x;;${src.uri.split('GROUP__')[1]}`;
                return;
              }
              const parts = src.music_idx?.split(';;');
              if (parts?.length >= 3) src.music_idx = `${parts[0]};;${parts[2]}`; // old type;;index;;refId -> type;;refId
            });
          }
        } else this.defaultSource();
      } catch (error) {
        console.log(error);
      }
    }
  }

  recommendClick() {
    this.sourceType = 1;
    this.getSource();
  }

  chkRecommendChange(event: any, key: any) {
    if (event.target.checked) {
      switch (key) {
        case 'danceability':
        case 'valence':
        case 'energy':
        case 'speechiness':
        case 'instrumentalness':
        case 'acousticness':
        case 'liveness':
        case 'popularity':
          this.sourceData[key] = { min: 0, max: 50 };
          break;
        case 'claim':
          this.sourceData[key] = {};
          this.sourceData[key].position = '100,100';
          this.sourceData[key].number = '1,1';
          this.sourceData[key].username = this.username;
          break;
        default:
          this.sourceData[key] = null;
          break;
      }
    }
    else {
      if (`${key}_text` in this.sourceData) {
        delete this.sourceData[`${key}_text`];
        delete this.sourceData[key];
      } else delete this.sourceData[key];
    }
  }

  getGenre() {
    const that = this;
    let uri = encodeURIComponent(`${environment.source}/spotify/browse/genre/get`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        that.genreList = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  genreChange(values: any) {
    if (values.length > 5) this.openSnackBar('Maximum genres are 5');
    else this.sourceData.genres = values;
  }

  getSourceLabel(item: any) {
    if (this.sourceType != 8) return item?.uri;
    const lastPart = item?.uri?.split(':')?.pop() || '';
    if (lastPart.startsWith('CLAIM__') || lastPart.startsWith('PROMO__')) return lastPart.split('__')[1];
    return this.editorService.getGroupName(lastPart, this.boomGroups);
  }

  getSelectableTopics(topics: any) {
    return topics?.filter((t: any) => t?.topic !== 'NO_CLAIM' && t?.topic !== 'NO_PROMO') || [];
  }

  generateUris(links: any, onlyId: any = false) {
    let uris: any = [];
    for (let link of links) {
      if (!link.includes('http')) continue;
      let sourceId;
      let linkType;
      if (link.includes('/track/')) {
        sourceId = link.match(/track\/(.*?)(\?|$)/);
        linkType = 'track';
      } else if (link.includes('/artist/')) {
        sourceId = link.match(/artist\/(.*?)(\?|$)/);
        linkType = 'artist';
      } else if (link.includes('/album/')) {
        sourceId = link.match(/album\/(.*?)(\?|$)/);
        linkType = 'album';
      } else if (link.includes('/playlist/')) {
        sourceId = link.match(/playlist\/(.*?)(\?|$)/);
        linkType = 'playlist';
      }
      if (sourceId) {
        sourceId = sourceId[1].trim();
        if (onlyId) uris.push(sourceId);
        else uris.push(`spotify:${linkType}:${sourceId}`);
      }
    }
    return uris;
  }

  artistTextChange(event: any) {
    let links = event.target.value.split(/\r?\n/);
    if (links.length > 5) this.openSnackBar('Maximum artists are 5');
    else {
      this.sourceData.artists_text = event.target.value;
      this.sourceData.artists = this.generateUris(links, true);
    }
  }

  trackTextChange(event: any) {
    let links = event.target.value.split(/\r?\n/);
    if (links.length > 5) this.openSnackBar('Maximum tracks are 5');
    else {
      this.sourceData.tracks_text = event.target.value;
      this.sourceData.tracks = this.generateUris(links, true);
    }
  }

  initSlider() {
    let keys = ['danceability', 'valence', 'energy', 'speechiness', 'instrumentalness', 'acousticness', 'liveness', 'popularity', 'claim'];
    for (let key of keys) {
      this.sliders[key] = {
        minValue: 0,
        maxValue: 50,
        options: {
          floor: 0,
          ceil: 100,
          getPointerColor: () => '#007bff',
          getSelectionBarColor: () => '#007bff',
          translate: (value, label) => `<span class="text-light">${value}</span>`,
          noSwitching: true
        }
      };
      if (key == 'claim') Object.assign(this.sliders[key], { minValue: 100, maxValue: 100 });
    }
  }

  sliderChange(event: any, key: any) {
    let slider = Object.assign({}, this.sliders[key]);
    if (key == 'claim') this.sourceData[key].position = `${slider.minValue},${slider.maxValue}`;
    else this.sourceData[key] = { min: slider.minValue, max: slider.maxValue };
  }

  radioClick() {
    this.sourceType = 2;
    this.getSource();
  }

  radioTextChange(event: any) {
    let links = event.target.value.split(/\r?\n/);
    this.sourceData.radio_text = event.target.value;
    this.sourceData.uris = this.generateUris(links);
  }

  numberTrackChange(value: any, type: any) {
    let numberTrack = parseInt(value) || 1;
    if (numberTrack > 50) {
      numberTrack = 50;
      this.openSnackBar('Maximum number track is 50');
    }
    if (type == 'playlist') {
      this.sourceData.number_track_playlist = numberTrack;
    } else if (type == 'radio') {
      this.sourceData.number_track_radio = numberTrack;
    }
  }

  rangeOptions: any = { start: [0, 10], connect: [false, true, false], input: ['1-1'] };
  @ViewChild('range') rangeElement: ElementRef;

  calcMinMax() {
    let totalMin = 0;
    let totalMax = 0;
    for (let item of this.rangeOptions.input) {
      if (item.includes('-')) {
        let [min, max] = item.split('-');
        min = parseInt(min) || 0;
        max = parseInt(max) || 0;
        totalMin += min;
        totalMax += max;
      }
    }
    this.sourceData.track_vip = `${totalMin}-${totalMax}`;
  }

  initRange() {
    const that = this;
    if (this.rangeElement.nativeElement.noUiSlider) this.rangeElement.nativeElement.noUiSlider.destroy();
    noUiSlider.create(this.rangeElement.nativeElement, {
      start: this.rangeOptions.start,
      connect: this.rangeOptions.connect,
      behaviour: 'tap-drag',
      keyboardSupport: false,
      tooltips: {
        to: (value) => value.toFixed(0)
      },
      pips: {
        mode: noUiSlider.PipsMode.Count,
        values: 11,
        density: 9,
        stepped: true
      },
      step: 10,
      range: {
        'min': 0,
        'max': 100
      }
    });
    this.calcMinMax();
    $('.noUi-origin .noUi-handle:odd').each((i, el) => {
      $(el).append(`
        <input type="text" value="${that.rangeOptions.input[i]}" title="Number of tracks" class="form-control bg-dark border-secondary text-light p-1" style="position: absolute; left: 50%; bottom: 120%; transform: translate(-50%, 0); width: 50px;">
      `);
      $(el).children('input').on('input', (e) => {
        that.rangeOptions.input[i] = e.target.value;
        that.calcMinMax();
      });
    });
    this.rangeElement.nativeElement.noUiSlider.on('update', (values, handle) => {
      let parseValues = values.map(e => parseInt(e));
      that.rangeOptions.start = parseValues;
    });
  }

  addRange() {
    if (this.rangeOptions.start.length >= 6) return;
    let [end] = this.rangeOptions.start.slice(-1);
    this.rangeOptions.start = [...this.rangeOptions.start, end + 10, end + 20];
    this.rangeOptions.connect = [...this.rangeOptions.connect, true, false];
    this.rangeOptions.input = [...this.rangeOptions.input, '1-1'];
    this.initRange();
  }

  deleteRange() {
    if (this.rangeOptions.start.length > 2) {
      this.rangeOptions.start.splice(-2, 2);
      this.rangeOptions.connect.splice(-2, 2);
      this.rangeOptions.input.splice(-1, 1);
      this.initRange();
    }
  }

  async playlistClick(type: any) {
    this.sourceType = type;
    this.sourceData = {};
    this.rangeOptions = { start: [0, 10], connect: [false, true, false], input: ['1-1'] };
    if (this.layerData && this.layerData.type == 'lyric') this.rangeOptions = { start: [90, 100], connect: [false, true, false], input: ['1-1'] };
    await this.getSource();
    if (this.sourceType != 8) setTimeout(() => this.initRange(), 1000);
  }

  playlistTextChange(event: any) {
    let previousLinks = this.sourceData.playlist_text ? this.sourceData.playlist_text.split(/\r?\n/) : [];
    this.sourceData.playlist_text = event.target.value;
    if (!this.sourceData.sources) this.sourceData.sources = [];
    let currentLinks = event.target.value.split(/\r?\n/);
    let diffLinks = previousLinks.filter(x => !currentLinks.includes(x)).concat(currentLinks.filter(x => !previousLinks.includes(x)));
    let validLinks = diffLinks.filter((e, i, self) => e.includes('http') && i == self.findIndex(x => x == e));
    for (let link of validLinks) {
      let obj;
      link = link.trim();
      if (link.includes('spotify')) {
        if (link.includes('/playlist/')) obj = { uri: `spotify:playlist:${link.match(/playlist\/(.*?)(\?|$)/)[1]}`, number_vip: 20 };
      }
      else if (link.includes('soundcloud')) obj = { uri: `soundcloud:playlist:${link}`, number_vip: 20 };
      else if (link.includes('drive/folders')) obj = { uri: `gdrive:folder:${link.match(/folders\/(.*?)(\?|$)/)[1]}`, number_vip: 20 };
      else if (link.includes('deezer')) {
        obj = { number_vip: 20 };
        if (link.includes('/track/')) {
          obj.uri = `deezer:track:${link.match(/track\/(.*?)(\?|$)/)[1]}`;
        } else if (link.includes('/artist/')) {
          obj.uri = `deezer:artist:${link.match(/artist\/(.*?)(\?|$)/)[1]}`;
        } else if (link.includes('/playlist/')) {
          obj.uri = `deezer:playlist:${link.match(/playlist\/(.*?)(\?|$)/)[1]}`;
        }
      }
      if (obj) {
        const index = this.sourceData.sources.findIndex(x => x.uri == obj.uri);
        if (index == -1) this.sourceData.sources.push(obj);
        else this.sourceData.sources.splice(index, 1);
      }
    }
  }

  async resetSource() {
    const that = this;
    let sourceId = '';
    if (this.controlType.includes('collection:music')) {
      sourceId = that.controlType.split(':').pop();
    } else if (this.layerData.source_id) sourceId = this.layerData.source_id;
    if (sourceId) {
      let uri = encodeURIComponent(`${environment.source}/config/reset-old-data/${sourceId}`);
      axios.get(`/pass/${uri}`)
        .then((response) => {
          that.openSnackBar(`Reseted`);
        })
        .catch((error) => {
          console.log(error);
        });
    } else this.openSnackBar(`No sources`);
    this.sourceValidationErrors.clear();
  }

  chkBoomVipChange(checked: any) {
    Object.assign(this.sourceData, { is_boom_vip: checked, boom_vip: '' });
  }

  boomVipChange(value: any, type: any = '') {
    if (!value) this.sourceData.boom_vip = '';
    else {
      if (type) value = `${type}__${value}`;
      this.sourceData.boom_vip = `deezer:boom:${value}__PRIORITY`;
    }
  }

  boomGroups: any = [];

  getBoomGroups() {
    this.editorService.getBoomGroups(this.username, this.isPortrait).then((results) => this.boomGroups = results).catch(() => { });
  }

  deezerBoomChange(value: any, type: any = '') {
    if (!value) this.sourceData.deezer_boom = '';
    else {
      if (type) value = `${type}__${value}`;
      this.sourceData.deezer_boom = value;
      if (!this.sourceData.sources) this.sourceData.sources = [];
      this.sourceData.sources[0] = { uri: `deezer:boom:${value}${this.sourceData.deezer_boom_ordering ? this.sourceData.deezer_boom_ordering : ''}`, number_vip: -1 };
    }
  }

  deezerBoomOrderingChange(value: any) {
    this.sourceData.deezer_boom_ordering = value;
    if (!this.sourceData.sources) this.sourceData.sources = [];
    this.sourceData.sources[0] = { uri: `deezer:boom:${this.sourceData.deezer_boom}${value}`, number_vip: -1 };
  }

  async topicTypeChange(value: any) {
    this.sourceData.claim.topic_type = value;
    this.claimList = await this.getClaims(value);
  }

  sourceValidationErrors: Set<number> = new Set();

  validateSourceSequence(): { isValid: boolean; errorIndexes: number[]; errorType?: string } {
    const sources = this.sourceData.sources;
    const errorIndexes: number[] = [];

    const hasEpicInSources = sources.some(x => x.music_type === 'EPIC');
    if (!hasEpicInSources) return { isValid: true, errorIndexes: [] };

    let totalEpic = 0;
    let totalNonEpic = 0;

    sources.forEach(source => {
      const total = (source.number_vip || 0) * (source.repeat || 0);
      if (source.music_type === 'EPIC') totalEpic += total;
      else totalNonEpic += total;
    });

    if (totalEpic < totalNonEpic) {
      sources.forEach((source, idx) => {
        if (source.music_type !== 'EPIC') errorIndexes.push(idx);
      });
      return { 
        isValid: false, 
        errorIndexes: errorIndexes,
        errorType: 'total'
      };
    }

    let consecutiveNonEpicTotal = 0;
    let nonEpicGroup: number[] = [];

    for (let i = 0; i < sources.length; i++) {
      if (sources[i].music_type !== 'EPIC') {
        const total = (sources[i].number_vip || 0) * (sources[i].repeat || 0);
        consecutiveNonEpicTotal += total;
        nonEpicGroup.push(i);

        if (consecutiveNonEpicTotal > 2) {
          nonEpicGroup.forEach(idx => {
            if (!errorIndexes.includes(idx)) errorIndexes.push(idx);
          });
        }
      } else {
        consecutiveNonEpicTotal = 0;
        nonEpicGroup = [];
      }
    }

    return {
      isValid: errorIndexes.length === 0,
      errorIndexes: errorIndexes,
      errorType: errorIndexes.length > 0 ? 'consecutive' : undefined
    };
  }

  hasSourceValidationError(index: number): boolean {
    return this.sourceValidationErrors.has(index);
  }

  async saveSource(event: any) {
    if (!('genres' in this.sourceData) && !('artists' in this.sourceData) && !('tracks' in this.sourceData) && !('uris' in this.sourceData) && !('sources' in this.sourceData)) this.openSnackBar('Please select a genre, group, artist, track or fill in a link');
    else if (('genres' in this.sourceData) && (this.sourceData.genres == null || !this.sourceData.genres.length)) this.openSnackBar('Please fill in a genre');
    else if (('artists' in this.sourceData) && (this.sourceData.artists == null || !this.sourceData.artists.length)) this.openSnackBar('Please fill in a artist');
    else if (('tracks' in this.sourceData) && (this.sourceData.tracks == null || !this.sourceData.tracks.length)) this.openSnackBar('Please fill in a track');
    else if (('uris' in this.sourceData) && !this.sourceData.uris.length && this.sourceType == 2) this.openSnackBar('Please fill in a spotify link');
    else if (('sources' in this.sourceData) && !this.sourceData.sources.length && this.sourceType == 3) this.openSnackBar('Please fill in a spotify playlist link');
    else if (('sources' in this.sourceData) && !this.sourceData.sources.length && this.sourceType == 4) this.openSnackBar('Please fill in a soundcloud playlist link');
    else if (('sources' in this.sourceData) && !this.sourceData.sources.length && this.sourceType == 5) this.openSnackBar('Please fill in a drive folder link');
    else if (('sources' in this.sourceData) && !this.sourceData.sources.length && this.sourceType == 6) this.openSnackBar('Please fill in a deezer link');
    else if (('sources' in this.sourceData) && !this.sourceData.sources.length && this.sourceType == 7) this.openSnackBar('Please fill in a genre');
    else if (('sources' in this.sourceData) && !this.sourceData.sources.length && this.sourceType == 8) this.openSnackBar('Please fill in a group');
    else if ((this.layerData.type == 'compilation' || this.layerData.type == 'mix_lyric') && !('claim' in this.sourceData) && this.sourceType != 8) this.openSnackBar('Please fill in a claim');
    else if (('claim' in this.sourceData) && !this.sourceData.claim.topic) this.openSnackBar('Please fill in a Claim or Promo topic');
    else {
      const validationResult = this.validateSourceSequence();
      const claimResult = this.validateClaimLimits();
      if (!validationResult.isValid) {
        this.sourceValidationErrors = new Set(validationResult.errorIndexes);

        let errorMessage = '';
        if (validationResult.errorType === 'total') {
          errorMessage = `Total EPIC tracks must be >= total non-EPIC tracks. Error at positions: ${validationResult.errorIndexes.map(i => i + 1).join(', ')}`;
        } else if (validationResult.errorType === 'consecutive') {
          errorMessage = `Non-EPIC sources cannot have more than 2 consecutive tracks. Error at positions: ${validationResult.errorIndexes.map(i => i + 1).join(', ')}`;
        }

        this.openSnackBar(errorMessage);
      } else if (!claimResult.isValid) {
        this.sourceValidationErrors = new Set(claimResult.errorIndexes);
        this.openSnackBar(`CLAIM tracks exceed topic total. Error at positions: ${claimResult.errorIndexes.map(i => i + 1).join(', ')}`);
      } else {
        this.sourceValidationErrors.clear();
        const that = this;
        if (this.sourceType != 1 && this.sourceType != 2) {
          this.sourceData.positions = [];
          this.rangeOptions.input.forEach((el, i) => {
            this.sourceData.positions[i] = { start: this.rangeOptions.start[i + i], end: this.rangeOptions.start[i + i + 1], value: this.rangeOptions.input[i] };
          });
        }
        if (this.sourceType == 8) this.sourceData.is_music_short = this.isPortrait;
        let sourceId = '';
        // hub modal can be closed mid-request, which reselects the layer
        const currentControlType = this.controlType;
        if (currentControlType.includes('collection:music')) {
          sourceId = currentControlType.split(':').pop();
        } else if (this.layerData.source_id) sourceId = this.layerData.source_id;
        if (this.sourceData.claim) this.sourceData.claim.username = this.username;
        let formData = new FormData();
        formData.append('data', JSON.stringify(this.sourceData));
        formData.append('type', this.sourceType);
        formData.append('id', sourceId);
        let uri = encodeURIComponent(`${environment.source}/config/add`);
        axios.post(`/pass/${uri}`, formData)
          .then(async (response) => {
            let obj = {
              music_data: [{ uri: `automusic:source:${response.data.id}` }],
              source_id: response.data.id
            };
            if (currentControlType.includes('collection:music')) {
              let collectionId = currentControlType.split(':')[2];
              uri = encodeURIComponent(`${environment.magic}/collection/load/${collectionId}`);
              let response = await axios.get(`/pass/${uri}`);
              let results = JSON.parse(response.data.data);
              if (results.hasOwnProperty('data')) {
                let diff = results.data.filter(e => !obj.music_data.find(x => x.uri == e.uri));
                results.data = obj.music_data.concat(diff);
                results.data = results.data.map(e => ({...e, count: 0, status: 1}));
              }
              formData = new FormData();
              formData.append('id', collectionId);
              formData.append('data', JSON.stringify(results));
              uri = encodeURIComponent(`${environment.magic}/collection/update`);
              await axios.post(`/pass/${uri}`, formData);
            } else {
              Object.assign(obj, { layer_id: that.layerData.id, layer_name: that.layerData.text });
              that.changedControl.emit({ id: that.layerData.id, type: 'sourceItem', sourceItem: obj });
            }
            $('#hubModal').modal('hide');
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  clearSource() {
    this.sourceData = {};
    this.changedControl.emit({ id: this.layerData.id, type: 'sourceItem', sourceItem: null });
  }

  trackSize: any = null;
  previewTracks: any = [];

  checkTrack() {
    if (!('genres' in this.sourceData) && !('artists' in this.sourceData) && !('tracks' in this.sourceData)) this.openSnackBar('Please select a genre, artist, track');
    else if (('genres' in this.sourceData) && (this.sourceData.genres == null || !this.sourceData.genres.length)) this.openSnackBar('Please fill in a genre');
    else if (('artists' in this.sourceData) && (this.sourceData.artists == null || !this.sourceData.artists.length)) this.openSnackBar('Please fill in a artist');
    else if (('tracks' in this.sourceData) && (this.sourceData.tracks == null || !this.sourceData.tracks.length)) this.openSnackBar('Please fill in a track');
    else {
      const that = this;
      let formData = new FormData();
      formData.append('data', JSON.stringify(this.sourceData));
      let uri = encodeURIComponent(`${environment.source}/config/recommend/check`);
      axios.post(`/pass/${uri}`, formData)
        .then(function (response) {
          that.trackSize = 0;
          if (response.data.seeds.length) {
            for (let item of response.data.seeds) {
              that.trackSize += item.afterFilteringSize;
            }
          }
          that.previewTracks = response.data.tracks;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  async getClaims(type: any = '') {
    let results = [];
    try {
      let uri = encodeURIComponent(`${environment.music}/api/claim/topic?type=${type}&claim_type=${this.layerData.type == 'lyric' ? 'lyric' : 'mix'}&username=${this.username}`);
      let response = await axios.get(`/pass/${uri}`);
      results = response.data;
    } catch (error) {
      console.log(error);
    }
    return results;
  }

  setEffectSlider(isEmpty: any = false) {
    if (isEmpty) this.effectSliders = [];
    else {
      this.effectSliders = [
        {
          label: 'Offset X',
          type: 'offsetX',
          value: 5,
          options: {
            floor: -10,
            ceil: 10,
            showSelectionBarFromValue: 0,
            getPointerColor: () => '#007bff',
            getSelectionBarColor: () => '#007bff',
            translate: (value, label) => `<span class="text-light">${value}</span>`
          }
        },
        {
          label: 'Offset Y',
          type: 'offsetY',
          value: 5,
          options: {
            floor: -10,
            ceil: 10,
            showSelectionBarFromValue: 0,
            getPointerColor: () => '#007bff',
            getSelectionBarColor: () => '#007bff',
            translate: (value, label) => `<span class="text-light">${value}</span>`
          }
        },
        {
          label: 'Opacity',
          type: 'opacity',
          value: 40,
          options: {
            floor: 0,
            ceil: 100,
            showSelectionBar: true,
            getPointerColor: () => '#007bff',
            getSelectionBarColor: () => '#007bff',
            translate: (value, label) => `<span class="text-light">${value}</span>`
          }
        }
      ];
      Object.assign(this.layerData.effect, { offsetX: 5, offsetY: 5, opacity: 40 });
    }
  }

  effectClick(type: any) {
    if (!this.layerData.hasOwnProperty('effect')) this.layerData.effect = { data: [] };
    if (type == 'none') this.setEffectSlider(true);
    else this.setEffectSlider();
    this.layerData.effect.type = type;
    this.changedControl.emit({ id: this.layerData.id, type: 'effect', effect: this.layerData.effect });
  }

  effectSliderChange(value: any, slider: any) {
    switch (slider.type) {
      case 'offsetX':
        this.layerData.effect.offsetX = value;
        break;
      case 'offsetY':
        this.layerData.effect.offsetY = value;
        break;
      case 'opacity':
        this.layerData.effect.opacity = value;
        break;
    }
    this.changedControl.emit({ id: this.layerData.id, type: 'effect', effect: this.layerData.effect });
  }

  showOverlay() {
    $('#overlayTab li:first-child a').tab('show');
    $('#controlModal').modal('show');
  }

  hideOverlay() {
    $('#controlModal').modal('hide');
  }

  @ViewChild('imgSearchTyping') imgSearchTyping: ElementRef;
  @ViewChild('fontSearchTyping') fontSearchTyping: ElementRef;
  @ViewChild('uploadedInput') uploadedInputEl: ElementRef;

  loadMore(type: any, page: any, query: any = null) {
    page++;
    switch (type) {
      case 'font':
        if (!query) this.getFonts(page);
        else this.getFonts(page, query);
        break;
      case 'video':
        if (!query) this.getVideos(page);
        else this.getVideos(page, query);
        break;
      case 'image':
        if (!query) this.getImages(page);
        else this.getImages(page, query);
        break;
      case 'canva':
        this.getCanvaByCate(this.selectedCate, page);
        break;
      case 'canvaImage':
        this.getCanvaImages(this.imgSearchTyping.nativeElement.value, page);
        break;
      case 'canvaFont':
        this.getCanvaFonts(this.fontSearchTyping.nativeElement.value, page);
        break;
      case 'element':
        this.getElements(page);
        break;
      default:
        this.getAudio(page);
        break;
    }
  }

  insertFont(fontName: any, fontUrl: any, id: any = 0) {
    const fontIndex = this.fontList.results.findIndex(x => x.file_name.toLowerCase() == fontName.toLowerCase());
    if (fontIndex == -1) this.fontList.results.push({ direct_link: fontUrl, file_name: fontName, id: id });
    else this.fontList.results[fontIndex] = { direct_link: fontUrl, file_name: fontName, id: id };
  }

  getFonts(page: any = 1, name: any = null) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/resource/get/font/${this.username}/${this.limit}/${page}/${name}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length) {
          let styleElement = document.createElement('style');
          for (let item of response.data) {
            let fontName = item.file_name.split('.').shift();
            that.insertFont(fontName, item.direct_link, item.id);
            styleElement.appendChild(document.createTextNode(`@font-face {font-family: "${fontName}"; src: url("${item.direct_link}")}`));
          }
          document.head.appendChild(styleElement);
          that.fontList.page = page;
        } else {
          that.fontList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getVideos(page: any = 1, name: any = null) {
    const that = this;
    if (page == 1) Object.assign(this.videoList, { results: [], page: 1 });
    let uri = encodeURIComponent(`${environment.magic}/resource/get/video/${this.username == null ? 'all' : this.username}/${this.limit}/${page}/${name}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.videoList.results = [...that.videoList.results, ...response.data];
          that.videoList.page = page;
        } else {
          that.videoList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getImages(page: any = 1, name: any = null) {
    const that = this;
    if (page == 1) Object.assign(this.imageList, { results: [], page: 1 });
    let uri = encodeURIComponent(`${environment.magic}/resource/get/image/${this.username == null ? 'all' : this.username}/${this.limit}/${page}/${name}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.imageList.results = [...that.imageList.results, ...response.data];
          that.imageList.page = page;
        } else {
          that.imageList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getAudio(page: any = 1) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/resource/get/audio/${this.username == null ? 'all' : this.username}/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.audioList.results = [...that.audioList.results, ...response.data];
          that.audioList.page = page;
        } else {
          that.audioList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCates() {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/canva/get/cate-list`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        that.cateList = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaByCate(cate: any, page: any = 1) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/canva/get/${this.canvaGetType}/${cate}/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.canvaList.results = [...that.canvaList.results, ...response.data];
          that.canvaList.page = page;
        } else {
          that.canvaList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  getCanvaById(canvaType: any, value: any, id: any) {
    return new Promise((resolve, reject) => {
      let result = null;
      let uri = encodeURIComponent(`${environment.magic}/canva/${canvaType}/search/${value}/${id}`);
      axios.get(`/pass/${uri}`)
        .then(function (response) {
          if (response.data.id != 0) {
            if (response.data.sources != undefined) {
              response.data.sources = JSON.parse(response.data.sources);
            }
            if (response.data.images != undefined) {
              response.data.images = JSON.parse(response.data.images);
            }
            result = response.data;
          }
          resolve(result);
        })
        .catch(function (error) {
          console.log(error);
        });
    });
  }

  getCanvaImages(value: any, page: any = 1) {
    const that = this;
    this.isLoading = true;
    if (this.imgSearchType == 'id') {
      this.getCanvaById('image', this.imgSearchType, value).then(response => {
        if (response != null) this.canvaImageList.results.push(response);
        this.canvaImageList.page = -1;
        this.isLoading = false;
      });
    } else {
      let uri = encodeURIComponent(`${environment.magic}/canva/image/search/${this.imgSearchType}/${value}/${this.limit}/${page}`);
      axios.get(`/pass/${uri}`)
        .then(function (response) {
          if (response.data.length > 0) {
            response.data = response.data.map(e => {
              e.sources = JSON.parse(e.sources);
              return e;
            });
            that.canvaImageList.results = [...that.canvaImageList.results, ...response.data];
            that.canvaImageList.page = page;
          } else {
            that.canvaImageList.page = -1;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(() => {
          that.isLoading = false;
        });
    }
  }

  getCanvaFonts(value: any, page: any = 1) {
    const that = this;
    this.isLoading = true;
    if (this.fontSearchType == 'id') {
      this.getCanvaById('font', this.fontSearchType, value).then(response => {
        if (response != null) this.canvaFontList.results.push(response);
        this.canvaFontList.page = -1;
        this.isLoading = false;
      });
    } else {
      let uri = encodeURIComponent(`${environment.magic}/canva/font/search/${this.fontSearchType}/${value}/${this.limit}/${page}`);
      axios.get(`/pass/${uri}`)
        .then(function (response) {
          if (response.data.length > 0) {
            response.data = response.data.map(e => {
              e.sources = JSON.parse(e.sources);
              e.images = JSON.parse(e.images);
              return e;
            });
            that.canvaFontList.results = [...that.canvaFontList.results, ...response.data];
            that.canvaFontList.page = page;
          } else {
            that.canvaFontList.page = -1;
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(() => {
          that.isLoading = false;
        });
    }
  }

  urCanvaChannelChange(value: any) {
    let selectedOption = $(`#urCanvaChannels option[value="${value}"]`);
    if (!selectedOption.length) return;
    Object.assign(this.urCanva, { video: { results: [], page: 1 }, image: { results: [], page: 1 }, font: { results: [], page: 1 }, channel: { id: selectedOption.val(), name: selectedOption.text() } });
    this.getStocks(this.urCanva.channel.id);
  }

  getStocks(channelId: any) {
    const that = this;
    this.isLoading = true;
    let uri = encodeURIComponent(`${environment.magic}/stock/manger/get/${channelId}`);
    axios.get(`/pass/${uri}`)
      .then((response) => {
        if (response.data.id != undefined) {
          if (response.data.canva_videos != undefined) {
            const canvaVideos = JSON.parse(response.data.canva_videos);
            for (const [key, value] of Object.entries(canvaVideos)) {
              that.getCanvaById('video', 'id', value).then(response => {
                if (response != null) that.urCanva.video.results.push(response);
                that.urCanva.video.page = -1;
              });
            }
          }
          if (response.data.canva_images != undefined) {
            const canvaImages = JSON.parse(response.data.canva_images);
            for (const [key, value] of Object.entries(canvaImages)) {
              that.getCanvaById('image', 'id', value).then(response => {
                if (response != null) that.urCanva.image.results.push(response);
                that.urCanva.image.page = -1;
              });
            }
          }
          if (response.data.canva_fonts != undefined) {
            const canvaFonts = JSON.parse(response.data.canva_fonts);
            for (const [key, value] of Object.entries(canvaFonts)) {
              that.getCanvaById('font', 'id', value).then(response => {
                if (response != null) that.urCanva.font.results.push(response);
                that.urCanva.font.page = -1;
              });
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        that.isLoading = false;
      });
  }

  getElements(page: any = 1) {
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/resource/get/image/star_effect/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then(function (response) {
        if (response.data.length > 0) {
          that.elementList.results = [...that.elementList.results, ...response.data];
          that.elementList.page = page;
        } else {
          that.elementList.page = -1;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  fontFileInput(file: any) {
    if (!file.name.includes('.ttf') && !file.name.includes('.otf')) {
      this.openSnackBar('Please select a valid font (.ttf, .otf)');
      return;
    }
    const that = this;
    this.isLoading = true;
    let formData = new FormData();
    formData.append('user_name', this.username);
    formData.append('file_input', file, file.name);
    let uri = encodeURIComponent(`${environment.magic}/resource/font`);
    axios.post(`/pass-file/${uri}`, formData)
      .then((response) => {
        let fontName = file.name.split('.').shift();
        that.changedControl.emit({
          id: that.layerData.id,
          type: 'uploadFont',
          fontName: fontName,
          fontUrl: response.data.directly,
          fontFormat: response.data.ext,
          md5: response.data.md5
        });
        that.insertFont(fontName, response.data.directly, response.data.id);
        that.getFonts();
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        that.isLoading = false;
        that.hideOverlay();
      });
  }

  imageFileInput(file: any, resourceType: any) {
    const that = this;
    this.isLoading = true;
    let formData = new FormData();
    formData.append('user_name', this.username);
    if (resourceType == 'image-drive') formData.append('file_input', file.match(/d\/(.*?)\/view/)[1]);
    else formData.append('file_input', file, file.name);
    let uri = encodeURIComponent(`${environment.magic}/resource/${resourceType}`);
    axios.post(`/pass/${uri}`, formData)
      .then((response) => {
        that.changedControl.emit({
          id: that.layerData.id,
          type: 'image',
          directUrl: response.data.directly,
          ext: response.data.ext,
          url: response.data.drive,
          md5: response.data.md5,
          width: response.data.width,
          height: response.data.height
        });
        that.imageList = { results: [], page: 1 };
        that.getImages();
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        that.isLoading = false;
        that.hideOverlay();
      });
  }

  async algorithmChange(value: any) {
    this.hubData.al = value;
    let currentLayer;
    if (!this.controlType.includes('collection')) currentLayer = Object.assign({}, { id: this.layerData.id, text: this.layerData.text });
    if (this.controlType.includes('collection')) {
      let collectionId = this.controlType.split(':')[2];
      let uri = encodeURIComponent(`${environment.magic}/collection/load/${collectionId}`);
      let response = await axios.get(`/pass/${uri}`);
      let results = JSON.parse(response.data.data);
      results.al = value;
      let formData = new FormData();
      formData.append('id', collectionId);
      formData.append('data', JSON.stringify(results));
      uri = encodeURIComponent(`${environment.magic}/collection/update`);
      await axios.post(`/pass/${uri}`, formData);
    } else if (currentLayer) {
      let obj = { layer_id: currentLayer.id, layer_name: currentLayer.text, al: value };
      this.changedControl.emit({ id: currentLayer.id, type: 'hubItem', hubItem: obj, lastDriveLink: null });
    }
    this.openSnackBar('Updated algorithm', 1000);
  }

  zipFileInput(file: any, resourceType: any) {
    const that = this;
    this.isLoading = true;
    let currentLayer;
    // hub modal can be closed mid-upload, which reselects the layer
    const currentControlType = this.controlType;
    if (!currentControlType.includes('collection')) currentLayer = Object.assign({}, { id: this.layerData.id, text: this.layerData.text });
    let lastDriveLink = null;
    let formData = new FormData();
    formData.append('user_name', this.username);
    if (resourceType.includes('drive-zip')) {
      if (file.includes('folders')) formData.append('file_input', file);
      else formData.append('file_input', file.match(/d\/(.*?)\/view/)[1]);
      lastDriveLink = file;
    } else formData.append('file_input', file, file.name);
    let uri = encodeURIComponent(`${environment.magic}/resource/${resourceType}`);
    axios.post(`/pass/${uri}`, formData)
      .then(async (response) => {
        let resources: any = [];
        for (let item of response.data) {
          if (!item.id) continue;
          resources.push({ resource_id: item.id, count: 0, status: 1, poster: item.poster });
        }
        that.hubData.data = resources;
        let _count = resources.length;
        that.hubData.static = `${_count}/${_count}`;
        if (currentControlType.includes('collection')) {
          let collectionId = currentControlType.split(':')[2];
          uri = encodeURIComponent(`${environment.magic}/collection/load/${collectionId}`);
          let response = await axios.get(`/pass/${uri}`);
          let results = JSON.parse(response.data.data);
          if (results.hasOwnProperty('data')) {
            let diff = that.hubData.data.filter(e => !results.data.find(x => x.resource_id == e.resource_id));
            that.hubData.data = results.data.concat(diff);
            _count = that.hubData.data.length;
            that.hubData.static = `${_count}/${_count}`;
          }
          that.hubData.data.forEach(item => item.count = 0);
          let obj = { al: that.hubData.al, data: that.hubData.data, static: that.hubData.static };
          formData = new FormData();
          formData.append('id', collectionId);
          formData.append('data', JSON.stringify(obj));
          formData.append('avail_cnt', `${_count}`);
          formData.append('total_cnt', `${_count}`);
          uri = encodeURIComponent(`${environment.magic}/collection/update`);
          await axios.post(`/pass/${uri}`, formData);
        } else if (currentLayer) {
          that.hubData.layer_id = currentLayer.id;
          that.hubData.layer_name = currentLayer.text;
          that.changedControl.emit({ id: currentLayer.id, type: 'hubItem', hubItem: that.hubData, lastDriveLink });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        that.isLoading = false;
        that.hubData = { al: 'random-order' };
        $('#hubModal').modal('hide');
      });
  }

  canvaHubClick() {
    localStorage.setItem('canvaHub', JSON.stringify({
      al: this.hubData.al,
      layer_id: this.layerData.id,
      layer_name: this.layerData.text,
      hub_id: this.currentHub.id
    }));
    this.changedControl.emit({ id: this.layerData.id, type: 'canvaHub' });
    this.hubData = { al: 'random-order' };
    $('#hubModal').modal('hide');
  }

  videoFileInput(file: any, resourceType: any) {
    const that = this;
    this.isLoading = true;
    let formData = new FormData();
    formData.append('user_name', this.username);
    if (resourceType == 'video-drive') formData.append('file_input', file.match(/d\/(.*?)\/view/)[1]);
    else formData.append('file_input', file, file.name);
    let uri = encodeURIComponent(`${environment.magic}/resource/${resourceType}`);
    axios.post(`/pass/${uri}`, formData)
      .then((response) => {
        that.changedControl.emit({
          id: that.layerData.id,
          type: 'video',
          directUrl: response.data.directly,
          ext: response.data.ext,
          url: response.data.drive,
          poster: response.data.poster,
          md5: response.data.md5,
          width: response.data.width,
          height: response.data.height
        });
        that.videoList = { results: [], page: 1 };
        that.getVideos();
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        that.isLoading = false;
        that.hideOverlay();
      });
  }

  uploadStatus: any = {};

  get uploadStatusType() {
    return this.controlType.includes('image') ? 'image' : 'video';
  }

  async awsFileInput(file: any, type: any) {
    this.isLoading = true;
    this.uploadStatus[type] = { progress: 0, count: 0, total: 1 };
    let result = await this.editorService.awsCreate(file, type, (percent: number) => {
      const perFile = 100 / this.uploadStatus[type].total;
      this.uploadStatus[type].progress = Math.min(100, (this.uploadStatus[type].count * perFile) + (percent / 100) * perFile);
    });
    if (!result.resource) {
      this.uploadStatus[type].progress = 100;
      this.isLoading = false;
      this.openSnackBar('Upload failed');
      return;
    }
    this.uploadStatus[type].count++;
    this.uploadStatus[type].progress = 100;
    let obj: any = {
      id: this.layerData.id,
      directUrl: result.resource.direct_link,
      type: type,
      ext: result.resource.ext,
      url: result.resource.drive_link,
      md5: result.resource.md5,
      width: result.resource.width,
      height: result.resource.height
    };
    if (result.poster) obj.poster = result.poster;
    else obj.poster = result.resource.poster;
    this.changedControl.emit(obj);
    if (type == 'video') {
      this.videoList = { results: [], page: 1 };
      this.getVideos();
    } else if (type == 'image') {
      this.imageList = { results: [], page: 1 };
      this.getImages();
    }
    this.isLoading = false;
    this.hideOverlay();
  }

  async awsFilesInput(files: any, type: any) {
    this.isLoading = true;
    let currentLayer;
    // hub modal can be closed mid-upload, which reselects the layer
    const currentControlType = this.controlType;
    if (!currentControlType.includes('collection')) currentLayer = Object.assign({}, { id: this.layerData.id, text: this.layerData.text });
    let resources: any = [];
    this.uploadStatus[type] = { progress: 0, count: 0, total: files.length };
    for (let file of files) {
      let result = await this.editorService.awsCreate(file, type, (percent: number) => {
        const perFile = 100 / this.uploadStatus[type].total;
        this.uploadStatus[type].progress = Math.min(100, (this.uploadStatus[type].count * perFile) + (percent / 100) * perFile);
      });
      if (!result.resource || (result.resource && !result.resource.id)) continue;
      this.uploadStatus[type].count++;
      resources.push({ resource_id: result.resource.id, count: 0, status: 1, poster: result.poster ? result.poster : result.resource.poster });
    }
    this.uploadStatus[type].progress = 100;
    this.hubData.data = resources;
    let _count = resources.length;
    this.hubData.static = `${_count}/${_count}`;
    if (currentControlType.includes('collection')) {
      let collectionId = currentControlType.split(':')[2];
      let uri = encodeURIComponent(`${environment.magic}/collection/load/${collectionId}`);
      let response = await axios.get(`/pass/${uri}`);
      let results = JSON.parse(response.data.data);
      if (results.hasOwnProperty('data')) {
        let diff = this.hubData.data.filter(e => !results.data.find(x => x.resource_id == e.resource_id));
        this.hubData.data = results.data.concat(diff);
        _count = this.hubData.data.length;
        this.hubData.static = `${_count}/${_count}`;
      }
      this.hubData.data.forEach(item => item.count = 0);
      let obj = { al: this.hubData.al, data: this.hubData.data, static: this.hubData.static };
      let formData = new FormData();
      formData.append('id', collectionId);
      formData.append('data', JSON.stringify(obj));
      formData.append('avail_cnt', `${_count}`);
      formData.append('total_cnt', `${_count}`);
      uri = encodeURIComponent(`${environment.magic}/collection/update`);
      await axios.post(`/pass/${uri}`, formData);
    } else if (currentLayer) {
      this.hubData.layer_id = currentLayer.id;
      this.hubData.layer_name = currentLayer.text;
      this.changedControl.emit({ id: currentLayer.id, type: 'hubItem', hubItem: this.hubData, lastDriveLink: null });
    }
    if (type == 'video') {
      this.videoList = { results: [], page: 1 };
      this.getVideos();
    } else if (type == 'image') {
      this.imageList = { results: [], page: 1 };
      this.getImages();
    }
    this.isLoading = false;
    this.hubData = { al: 'random-order' };
    $('#hubModal').modal('hide');
    this.openSnackBar(`${resources.length} ${type}s uploaded`, 3000);
  }

  audioFileInput(file: any) {
    const that = this;
    this.isLoading = true;
    let formData = new FormData();
    formData.append('user_name', this.username);
    formData.append('file_input', file, file.name);
    let uri = encodeURIComponent(`${environment.magic}/resource/audio`);
    axios.post(`/pass-file/${uri}`, formData)
      .then(function (response) {
        that.changedControl.emit({
          id: that.layerData.id,
          type: 'audio',
          directUrl: response.data.directly,
          ext: response.data.ext,
          url: response.data.drive,
          md5: response.data.md5
        });
        that.audioList = { results: [], page: 1 };
        that.getAudio();
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(() => {
        that.isLoading = false;
        that.hideOverlay();
      });
  }

  selectedImage(item: any) {
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'browseImage',
      directUrl: item.direct_link,
      ext: item.ext,
      url: item.drive_link,
      md5: item.md5,
      width: item.width,
      height: item.height
    });
    this.hideOverlay();
  }

  selectedVideo(item: any) {
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'browseVideo',
      directUrl: item.direct_link,
      ext: item.ext,
      url: item.drive_link,
      poster: item.poster,
      md5: item.md5,
      width: item.width,
      height: item.height
    });
    this.hideOverlay();
  }

  selectedFont(item: any) {
    let fontName = item.file_name.split('.').shift();
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'browseFont',
      fontName: fontName,
      fontUrl: item.direct_link,
      fontFormat: item.ext,
      md5: item.md5
    });
    this.insertFont(fontName, item.direct_link, item.id);
    this.hideOverlay();
  }

  selectedAudio(item: any) {
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'browseAudio',
      directUrl: item.direct_link,
      ext: item.ext,
      url: item.drive_link,
      md5: item.md5
    });
    this.hideOverlay();
  }

  rsDelete(id: any, type: any) {
    if (!id) {
      this.openSnackBar('ID not found');
      return;
    }
    const that = this;
    let uri = encodeURIComponent(`${environment.magic}/resource/delete/${type}/${id}`);
    axios.get(`/pass/${uri}`)
      .then((response) => that.openSnackBar(`Delete ${type} ${id} ${response.data.rs}`))
      .catch((error) => console.log(error));
  }

  cateChange(event: any) {
    this.selectedCate = event.target.value;
    this.canvaGetType = 'cate';
    this.canvaList = { results: [], page: 1 };
    this.getCanvaByCate(this.selectedCate);
  }

  canvaSearchChange(value: any) {
    this.selectedCate = value;
    this.canvaGetType = 'keyword';
    this.canvaList = { results: [], page: 1 };
    this.getCanvaByCate(this.selectedCate);
  }

  selectedCanva(item: any) {
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'canva',
      directUrl: item.url_pub,
      ext: item.ext,
      url: item.drive_link,
      poster: (item.poster != null && item.poster != undefined && item.poster.includes(',')) ? item.poster.split(',')[0] : item.poster,
      md5: item.md5,
      width: null,
      height: null
    });
    this.hideOverlay();
  }

  imgSearchChange(value: any) {
    this.canvaImageList = { results: [], page: 1 };
    this.getCanvaImages(value);
  }

  getThumbnailImage(sources: any) {
    return sources.find(e => e.quality == 'THUMBNAIL').url;
  }

  selectedCanvaImage(item: any) {
    let parts = item.url != null ? item.url.split('.') : '';
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'canvaImage',
      directUrl: item.url,
      ext: parts[parts.length - 1],
      url: item.drive1,
      md5: item.md5,
      width: item.width,
      height: item.height
    });
    this.hideOverlay();
  }

  fontSearchChange(value: any) {
    this.canvaFontList = { results: [], page: 1 };
    this.getCanvaFonts(value);
  }

  getFontImage(images: any) {
    return images.find(e => e.role == 'SCRIPT_PREVIEW').direct_link;
  }

  isTfFont(source: any) {
    return source.files.some(f => f.format.toLowerCase().includes('tf'));
  }

  selectedCanvaFont(source: any) {
    let f = source.files.find(f => f.format.toLowerCase().includes('tf'));
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'canvaFont',
      fontName: source.postscriptName,
      fontUrl: f.direct_link,
      fontFormat: f.format.toLowerCase(),
      md5: null
    });
    this.insertFont(source.postscriptName, f.direct_link);
    this.hideOverlay();
  }

  introData: any = { app: '', channel_type: '', channel_id: '', intro_type: '', video_type: '', videos: [] };

  getIntroTopics() {
    const that = this;
    let uri = encodeURIComponent(`${environment.music}/api/intro/topic?username=${this.username}`);
    axios.get(`/pass/${uri}`)
      .then((response) => that.introData.topic = response.data)
      .catch((error) => console.log(error));
  }

  getIntroVideos() {
    const that = this;
    let uri = encodeURIComponent(`${environment.music}/api/intro/video?username=${this.username}&app=${this.introData.app}&channel_type=${this.introData.channel_type}&channel_id=${this.introData.channel_id}&intro_type=${this.introData.intro_type}&video_type=${this.introData.video_type}`);
    axios.get(`/pass/${uri}`)
      .then((response) => that.introData.videos = response.data)
      .catch((error) => console.log(error));
  }

  selectedIntro(item: any) {
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'browseIntro',
      directUrl: item.intro_thumb,
      ext: 'mp4',
      url: item.intro_link,
      poster: item.intro_thumb,
      md5: null,
      width: !this.introData.intro_type ? null : this.introData.intro_type == 'LONG' ? 1920 : 1080,
      height: !this.introData.intro_type ? null : this.introData.intro_type == 'LONG' ? 1080 : 1920
    });
    this.hideOverlay();
  }

  selectedElement(item: any) {
    const tplIndex = this.layerData.arr_summon_template.findIndex(x => x == item.direct_link);
    if (tplIndex == -1) this.layerData.arr_summon_template.push(item.direct_link);
    else this.layerData.arr_summon_template.splice(tplIndex, 1);
    this.changedControl.emit({ id: this.layerData.id, type: 'summonTemplate', summonTemplates: this.layerData.arr_summon_template });
    this.hideOverlay();
  }

  checkFont() {
    const that = this;
    if (this.lyricSource == 'deezer') {
      let uri = encodeURIComponent(`${environment.track}/tracks/?check_font=&source=${this.lyricSource}&id=${this.lyricData.deezer_id}&font_url=${this.layerData.font_url}`);
      axios.get(`/pass/${uri}`)
        .then(function (response) {
          that.openSnackBar(response.data.message);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      let uri = encodeURIComponent(`${environment.track}/tracks/?check_font=&source=${this.lyricSource}&id=${this.lyricData.id}&font_url=${this.layerData.font_url}`);
      axios.get(`/pass/${uri}`)
        .then(function (response) {
          that.openSnackBar(response.data.message);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  calcFontSize() {
    const that = this;
    let formData = new FormData();
    formData.append('lyric_sync', this.lyricData.lyric_sync);
    formData.append('font_url', this.layerData.font_url);
    formData.append('width', this.layerData.position.width);
    formData.append('wrap_width', this.layerData.wrap_width);
    let uri = encodeURIComponent(`${environment.magic}/lyric/font/max-size`);
    axios.post(`/pass/${uri}`, formData)
      .then(function (response) {
        that.changedControl.emit({
          id: that.layerData.id,
          type: 'calcFontSize',
          fontSize: response.data.font_size,
          text: response.data.longest_line
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  testTextList(event: any) {
    const that = this;
    event.srcElement.innerText = '...';
    if (!this.layerData.job_id) delete this.layerData.job_id;
    let uri = encodeURIComponent(`http://65.21.242.170:5002/test/text-list`);
    axios.post(`/pass-json/${uri}`, this.layerData, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (response) {
        if (response.data.error == 0) {
          that.changedControl.emit({ id: that.layerData.id, type: 'imgTextList', imgTextList: response.data.data });
        } else that.openSnackBar(response.data.error);
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        event.srcElement.innerText = 'Test';
      });
  }

  sourceUsers: any = [];

  getSourceUsers() {
    this.editorService.getSourceUsers()
      .then((results) => this.sourceUsers = results)
      .catch((error) => console.log(error));
  }

  sourceUserChange(currentValues: any) {
    this.layerData.source_users = currentValues;
    this.changedControl.emit({ id: this.layerData.id, type: 'msSourceUsers', sourceUsers: currentValues });
  }

  sourceUserIndex(id: any) {
    return this.layerData?.source_users?.findIndex(x => x.id == id) + 1;
  }

  noSortComparator() {
    return 0;
  }

  getSourceTracksSummary(): any {
    const musicTypes: any = (this.sourceData?.sources || []).reduce((acc: any, cur: any) => {
      const type = cur.music_type || 'OTHER';
      acc[type] = (acc[type] || 0) + cur.number_vip * cur.repeat;
      return acc;
    }, {});
    const repeatAll = this.sourceData?.repeat_all || 1;
    let total = 0;
    for (const key in musicTypes) total += musicTypes[key];
    total *= repeatAll;
    return { total, musicTypes };
  }

  getMusicDataSummary(): any {
    return this.editorService.musicTypeSummary(this.controlType == 'mix_lyric' ? this.layerData?.mix_data : this.layerData?.music_data);
  }

  soundEffectData: any = { sound_effects: [{ group: undefined }] };

  clearSoundEffect() {
    this.soundEffectData = {};
    this.changedControl.emit({ id: this.layerData.id, type: 'soundEffect', soundEffect: null });
  }

  resetSoundEffect() {
    const that = this;
    if (this.layerData.sound_effect_id) {
      let uri = encodeURIComponent(`${environment.source}/config/reset-old-data/${this.layerData.sound_effect_id}`);
      axios.get(`/pass/${uri}`)
        .then((response) => that.openSnackBar(`Reseted`))
        .catch((error) => console.log(error));
    } else this.openSnackBar(`No sources`);
  }

  saveSoundEffect() {
    if (!('sources' in this.soundEffectData) || (('sources' in this.soundEffectData) && !this.soundEffectData.sources.length)) this.openSnackBar('Please fill in a group');
    else {
      const that = this;
      let formData = new FormData();
      formData.append('data', JSON.stringify(this.soundEffectData));
      formData.append('type', '9');
      formData.append('id', this.layerData.sound_effect_id);
      let uri = encodeURIComponent(`${environment.source}/config/add`);
      axios.post(`/pass/${uri}`, formData)
        .then(async (response) => {
          let obj = {
            sound_effect: [{ uri: `automusic:source:${response.data.id}` }],
            sound_effect_id: response.data.id,
            layer_id: that.layerData.id,
            layer_name: that.layerData.text
          };
          that.changedControl.emit({ id: that.layerData.id, type: 'soundEffect', soundEffect: obj });
          $('#soundEffectModal').modal('hide');
        })
        .catch((error) => console.log(error));
    }
  }

  getSoundEffectTracks() {
    return this.soundEffectData?.sources?.reduce((acc, cur) => acc + (cur.number_vip * cur.repeat), 0);
  }

  soundEffectChange(value: any, type: string, index: number) {
    this.soundEffectData[type][index].group = value;
    if (!this.soundEffectData.sources) this.soundEffectData.sources = [];
    this.soundEffectData.sources[index] = { uri: `deezer:boom:${value}`, number_vip: 1, repeat: 1, volume: 100 };
  }

  removeSoundEffect(type: string, index: number) {
    if (this.soundEffectData[type].length > 1) {
      this.soundEffectData[type].splice(index, 1);
      this.soundEffectData.sources.splice(index, 1);
    }
  }

  newSoundEffect(type: string) {
    this.soundEffectData[type].push({ group: undefined });
  }

  soundEffectDrop(event: any) {
    moveItemInArray(this.soundEffectData.sources, event.previousIndex, event.currentIndex);
  }

  async getSoundEffect() {
    let sourceId = this.layerData.sound_effect_id;
    if (sourceId) {
      try {
        let uri = encodeURIComponent(`${environment.source}/config/load/${sourceId}`);
        let response = await axios.get(`/pass/${uri}`);
        if (this.sourceType == response.data.type) this.soundEffectData = JSON.parse(response.data.data);
      } catch (error) { console.log(error) }
    }
  }

  validRepeat(event: any, index: number) {
    setTimeout(() => {
      let value = event.target.value;
      if (value > 10) value = 10;
      this.soundEffectData.sources[index].repeat = value;
    });
  }

  getTopicTotal(item: any): number {
    if (!item?.music_idx || item.music_type !== 'CLAIM') return null;
    const topic = item.music_idx.split(';;')[1];
    const found = (this.claimTopics || []).find((t: any) => t.topic === topic);
    return found ? (found.total || 0) : null;
  }

  validateClaimLimits(): { isValid: boolean; errorIndexes: number[] } {
    const errorIndexes: number[] = [];
    const sources = this.sourceData.sources || [];

    const topicUsage = new Map<string, { total: number; indexes: number[] }>();
    sources.forEach((item: any, index: number) => {
      if (item.music_type !== 'CLAIM' || !item.music_idx) return;
      const entry = topicUsage.get(item.music_idx) || { total: 0, indexes: [] };
      entry.total += (item.number_vip || 0) * (item.repeat || 1);
      entry.indexes.push(index);
      topicUsage.set(item.music_idx, entry);
    });

    const repeatAll = this.sourceData?.repeat_all || 1;
    topicUsage.forEach((entry) => {
      const max = this.getTopicTotal(sources[entry.indexes[0]]);
      if (max != null && entry.total * repeatAll > max) errorIndexes.push(...entry.indexes);
    });

    return { isValid: errorIndexes.length === 0, errorIndexes: errorIndexes.sort((a, b) => a - b) };
  }

  motionData: any = { compositions: [] };

  getCompositions() {
    const that = this;
    let uri = encodeURIComponent(`${environment.dr360studio}/items/composition?filter[status][_eq]=show`);
    axios.get(`/pass-dr/${uri}`)
      .then((response) => that.motionData.compositions = response.data.data)
      .catch((error) => console.log(error));
  }

  compositionChange(value: any) {
    this.layerData.comp_data.composition = value;
    let schema = value?.schema || [];
    for (let item of schema) {
      if (item.field && item.meta && item.meta.default_value !== undefined) {
        if (!this.layerData.render_data.data[item.field]) {
          this.layerData.render_data.data[item.field] = item.meta.default_value;
        }
      }
    }
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'motion',
      compData: this.layerData.comp_data,
      renderData: this.layerData.render_data,
    });
  }

  interfaceClick(event: any, field: string) {
    this.layerData.comp_data.field = field;
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'motion',
      compData: this.layerData.comp_data,
    });
  }

  async interfaceChange(value: any, type: string, field: string) {
    if (type == 'number') value = value.includes('.') ? parseFloat(value) : parseInt(value);
    this.layerData.render_data.data[field] = value;
    if (this.layerData.comp_data?.collection?.id && field == 'imageCount') {
      let uri = encodeURIComponent(`${environment.magic}/collection/load/${this.layerData.comp_data.collection.id}`);
      await axios.get(`/pass/${uri}`)
        .then((response) => {
          let obj = JSON.parse(response.data.data);
          if (this.layerData.comp_data.collection.type == 1) {
            let imageUrls = obj.data.map(e => e.poster);
            this.layerData.render_data.data[this.layerData.comp_data.field] = this.editorService.shuffle(imageUrls, this.layerData.render_data.data?.imageCount || 10);
          }
        });
    }
    this.changedControl.emit({
      id: this.layerData.id,
      type: 'motion',
      renderData: this.layerData.render_data,
    });
  }

  ngOnDestroy() {
    $('#compilationModal, #mixLyricModal').off('hidden.bs.modal.musicBackup');
  }
}
